<div class="wrapper">
    <!-- top navbar-->

    <!-- sidebar-->
    <ng-container *ngIf="tblName == 'txnAdminUsers'">
        <app-header class="topnavbar-wrapper"></app-header>
        <app-sidebar class="aside-container"></app-sidebar>
    </ng-container>

    <ng-container *ngIf="tblName == 'txnUsers'">
        <app-subscriber-header class="topnavbar-wrapper"></app-subscriber-header>
        <app-subscriber-sidebar class="aside-container"></app-subscriber-sidebar>
    </ng-container>

    <ng-container *ngIf="tblName == 'txnConsumerUsers'">
        <app-applicant-header class="topnavbar-wrapper"></app-applicant-header>
        <app-applicant-sidebar class="aside-container"></app-applicant-sidebar>
    </ng-container>


    <!-- offsidebar-->
    <app-offsidebar class="offsidebar"></app-offsidebar>
    <!-- Main section-->
    <section class="section-container">
        <!-- Page content-->
        <div class="content-wrapper">
            <router-outlet></router-outlet>
        </div>
    </section>
    <!-- Page footer-->
    <footer class="footer-container" app-footer></footer>
    <!-- <app-evee-assistant *ngIf="tblName == 'txnAdminUsers' || tblName == 'txnUsers'"></app-evee-assistant> -->
</div>